import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { CashAdvance } from '../models/cashAdvances/cash.advance';
import { tap, catchError } from 'rxjs/operators';
import { PageOption } from '../models/common/pageOption';
import { CashAdvanceFilter } from '../models/cashAdvances/cash.advance.filter';
import { PageOptionResult } from '../models/common/pageOptionResult';
import { RequestResult } from '../models/common/requestResult';
import { ErrorCollection } from '../models/common/errorCollection';

@Injectable()
export class CashAdvanceService {
  	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getCashAdvance(id: string): Observable<CashAdvance> {
		return this._http.get<CashAdvance>(`${this.origin}/api/cashadvances/${id}`)
			.pipe(
				tap(x => this.log(`getCashAdvance: id=${id}`)),
				catchError(this._logService.handleError<CashAdvance>('getCashAdvance'))
			);
	}

	getCashAdvanceList(filter: PageOption<CashAdvanceFilter>): Observable<PageOptionResult<CashAdvance>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<CashAdvance>>(`${this.origin}/api/cashadvances/${param}`)
			.pipe(
				tap(x => this.log(`getCashAdvancesList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<CashAdvance>>('getCashAdvancesList'))
			);
	}

	addCashAdvance(cashAdvance: CashAdvance): Observable<RequestResult<CashAdvance>> {
		return this._http.post<RequestResult<CashAdvance>>(`${this.origin}/api/cashadvances`, JSON.stringify(cashAdvance))
			.pipe(
				tap(x => this.log(`addCashAdvance: id=${cashAdvance.id}`)),
				catchError(this._logService.handleError<RequestResult<CashAdvance>>('addCashAdvance'))
			);
	}

	updateCashAdvance(cashAdvance: CashAdvance): Observable<RequestResult<CashAdvance>> {
		return this._http.put<RequestResult<CashAdvance>>(`${this.origin}/api/cashadvances/${cashAdvance.id}`, JSON.stringify(cashAdvance))
			.pipe(
				tap(x => this.log(`updateCashAdvance: id=${cashAdvance.id}`)),
				catchError(this._logService.handleError<RequestResult<CashAdvance>>('updateCashAdvance'))
			);
	}

	deleteCashAdvance(id: number): Observable<ErrorCollection> {
		return this._http.delete<ErrorCollection>(`${this.origin}/api/cashadvances/${id}`)
			.pipe(
				tap(x => this.log(`deleteCashAdvance: id=${id}`)),
				catchError(this._logService.handleError<ErrorCollection>('deleteCashAdvance'))
			);
	}

	private log(message: string) {
		this._messagesService.add('CashAdvanceService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/cash-advance.service.ts